import { useAppStore } from "../../../store/store";

const MenuBtn = () => {
  const mobileMenuIsOpen = useAppStore((state) => state.mobileMenuIsOpen);
  const setMobileMenuIsOpen = useAppStore((state) => state.setMobileMenuIsOpen);

  return (
    <div
      className={`${mobileMenuIsOpen ? "open" : "close"} mobMenu w-[30px] h-[30px] hidden flex-col gap-[7px] items-center justify-center cursor-pointer max-xl:flex z-[1000]`}
      onClick={() => {
        setMobileMenuIsOpen(!mobileMenuIsOpen);
      }}
    >
      <div className="menuOne bg-[#6B7280] h-[2px] w-[80%] "></div>
      <div className="menuTwo bg-[#6B7280] h-[2px] w-[80%] "></div>
      <div className="menuThree bg-[#6B7280] h-[2px] w-[80%] "></div>
    </div>
  );
};

export default MenuBtn;
